<template>
  <b-tab title="Plano de Manutenção" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="PlanoManutencaoPrint">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE SUPERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-1">
              <h4 class="exo-2 center-text pt-5">PLANO DE MANUTENÇÃO</h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="plano.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="plano.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: IDENTIFICAÇÃO DO EQUIPAMENTO :::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>CARACTERÍSTICAS DO EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Equipamento / Equipment</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Identificação / Identification</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-4">
              <p class="m-0 p-0">Código / Serial no.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.nome" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.sgcq" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.codigo" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Dimensões / Dimensions</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Fabricante / Manufacturer</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Peso / Weight</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Carga / Work load</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.dimensoes" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.fabricante" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.peso" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.carga" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="6" class="p-0">
              <p class="m-0 p-0">Descrição / Description</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Local / Local</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Resultado / Result</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="p-0 pl-2">
              <b-form-input size="sm" v-model="plano.detalhe" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="plano.local" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="plano.resultado" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: DETALHES MANUTENÇÃO :::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>DETALHES SOBRE A MANUTENÇÃO DO EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="m-0 p-0">
              <div class="p-3 m-1 borda-cliente max-size">
                <b-img
                  :src="imagem == null ? require('/static/images/report.png') : imagem"
                  class="max-size-img"
                  center
                  fluid
                  width="300"
                />
              </div>
            </b-col>
            <b-col cols="8" class="m-0 p-0">
              <b-row class="text-left m-1">
                <b-form-textarea v-model="plano.objetivo" :rows="linhas" />
              </b-row>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::: ITENS DAS MANUTENÇÃO :::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>MANUTENÇÕES REALIZADAS - HISTÓRICO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <b-table id="table-item" hover small :items="plano.itens" :fields="fields.item_manutencao">
                <template #cell(item)="data">
                  <div>
                    <b-form-textarea v-model="data.item.item" :rows="checks" />
                  </div>
                </template>
                <template #cell(historico)="data">
                  <b-list-group class="m-0 p-0">
                    <b-list-group-item v-for="item in data.item.historico" :key="item.id" class="m-0 p-0">
                      <b-form-datepicker
                        id="data"
                        v-model="item.data"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      ></b-form-datepicker>
                    </b-list-group-item>
                  </b-list-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::: ITENS DAS CONDIÇÕES ::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>RECOMENDAÇÕES GERAIS SOBRE O EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0">
              <b-form-textarea v-model="plano.observacao" :rows="linhas" />
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>TÉCNICO</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0">
              <div class="separador-div">
                <strong>RESPONSÁVEL</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp :profissional="plano.inspetor" :preview="stampInspetor" :posicao="'6rem'" key="insp-stamp-plano" />
            </b-col>
            <b-col cols="4" class="m-0 p-0">
              <responsavel-stamp
                :profissional="plano.responsavel"
                :preview="stampResponsavel"
                :posicao="'6rem'"
                key="resp-stamp-plano"
              />
            </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- ::::::::::::::::::::::::::::::: MODAL DE EDIÇÃO ::::::::::::::::::::::::::::::: -->
    <planomanutencao-modal ref="tPlanoManutencaolist" />
    <planomanutencao-itens-modal ref="tPlanoManutencaoItens" />
    <!-- :::::::::::::::::::::::::::: COMANDOS DO RELATÓRIO :::::::::::::::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="callItens()">
              <b-icon icon="file-break" variant="light" scale="1.1" class="mr-2" />Itens
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-input id="size-lines" type="number" size="sm" class="m-1 p-1" v-model="checks" />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import PlanoManutencao from "@/models_reports/PlanoManutencao";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import Files from "@/http/files";
import StampCertificado from "@/components/supports/StampCertificado";
import PlanoManutencaoModal from "@/components/modals/relatorio/PlanoManutencaoModal";
import PlanoManutencaoItensModal from "@/components/modals/relatorio/PlanoManutencaoItensModal";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "PlanoManutencaoReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "responsavel-stamp": StampCertificado,
    "planomanutencao-modal": PlanoManutencaoModal,
    "planomanutencao-itens-modal": PlanoManutencaoItensModal,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      plano: new PlanoManutencao(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      identificacao: "",
      stampInspetor: null,
      stampResponsavel: null,
      logoCliente: null,
      imagem: null,
      fields: new ReportFields(),
      files: new Files(this.$http),
      linhas: 10,
      checks: 8,
      printLaudo: {
        id: "PlanoManutencaoPrint",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          this.plano.servicos = this.getServicos;
          let servicoData = new Date(this.getLastServico[0].data);
          this.plano.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.plano.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-PMAN";
          this.identificacao = this.equipamento.sgcq;
          if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
            this.identificacao = this.equipamento.sgcq + " - " + this.equipamento.codigo;
          }

          //carrega as datas dos serviços no plano
          this.plano.setHistorico();          
          //carrega a imagem do equipamento
          this.files.downloadEquipamento(this.equipamento.sgcq).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.imagem = e.target.result;
            };
          });

          //carrega a logomarca do cliente
          this.files.downloadLogo(this.cliente.id).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.logoCliente = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.tPlanoManutencaolist.call(this.plano);
    },

    callItens() {
      this.$refs.tPlanoManutencaoItens.call(this.plano);
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getServicos } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getServicos,
      getLastServico,
    };
  },
};
</script>
<style lang="scss" scoped>
.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.center-text {
  text-align: justify; /* For Edge */
  text-align-last: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #9d0f0f; /* #ff0000; */
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

#sgcq-call {
  width: 6rem;
}

.menu-acoes {
  background-color: #112a4a;
}
.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
